module.exports = "<svg viewBox=\"0 0 9.2 18.8\"><path fill=\"#231F20\" d=\"M3.4 17.9v-7.5H1.2C.5 10.4 0 9.9 0 9.2 0 8.6.5 8 1.2 8h2.2V3c0-1.5 1.4-3 3.3-3h1.6c.5 0 .9.4.9.9s-.4.9-.9.9h-.8c-1.5 0-2.3.6-2.3 2.3V8h2.4c.7 0 1.2.6 1.2 1.3-.1.6-.6 1-1.2 1H5.2v7.5c0 .5-.4.9-.9.9-.5.1-.9-.3-.9-.8z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/facebook.svg
// module id = 297
// module chunks = 1